export const mutations = {
  OBS_RESET_DATA: "OBS_RESET_DATA",
  OBS_GO_TO_STEP: "OBS_GO_TO_STEP",
  OBS_PAGE_OBJECTIVE: "OBS_PAGE_OBJECTIVE",
  OBS_HOVER_PAGE_OBJECTIVE: "OBS_HOVER_PAGE_OBJECTIVE",
  OBS_ADD_INDUSTRY: "OBS_ADD_INDUSTRY",
  OBS_REMOVE_INDUSTRY: "OBS_REMOVE_INDUSTRY",
  OBS_OTHERS_OBJECTIVE: "OBS_OTHERS_OBJECTIVE",
  OBS_REPLACE_INDUSTRY: "OBS_REPLACE_INDUSTRY",
  OBS_DISABLED_BROWSE_TEMPLATE: "OBS_DISABLED_BROWSE_TEMPLATE",
  DO_GO_TO_STEP: "DO_GO_TO_STEP",
  DO_CLOSE_WIDGET_ON_BOARDING: "DO_CLOSE_WIDGET_ON_BOARDING",
  DO_OPEN_WIDGET_ON_BOARDING: "DO_OPEN_WIDGET_ON_BOARDING",
  DO_UPDATE_JOB_ROLE: "DO_UPDATE_JOB_ROLE",
  D0_UPDATE_BUSINESS_TYPE: "D0_UPDATE_BUSINESS_TYPE",
  DO_UPDATE_IS_SUBMIT_STEP: "DO_UPDATE_IS_SUBMIT_STEP",
  DO_UPDATE_SUBMITTING_STATUS: "DO_UPDATE_IS_SUBMIT_LOADING",
  DO_UPDATE_JOB_ROLE_VALUE: "DO_UPDATE_JOB_ROLE_VALUE"
};

export const actions = {
  GO_TO_STEP: "GO_TO_STEP",
  CLOSE_WIDGET_ON_BOARDING: "CLOSE_WIDGET_ON_BOARDING",
  OPEN_WIDGET_ON_BOARDING: "OPEN_WIDGET_ON_BOARDING",
  UPDATE_JOB_ROLE: "UPDATE_JOB_ROLE",
  UPDATE_JOB_ROLE_VALUE: "UPDATE_JOB_ROLE_VALUE",
  UPDATE_BUSINESS_TYPE: "UPDATE_BUSINESS_TYPE",
  LAST_STEP_SUBMIT: "LAST_STEP_SUBMIT",
  UPDATE_IS_SUBMIT_STEP: "UPDATE_IS_SUBMIT_STEP",
  UPDATE_SUBMITTING_STATUS: "UPDATE_IS_SUBMIT_LOADING",
  UPDATE_SURVEY_ONBOARDING: "UPDATE_SURVEY_ONBOARDING"
};
